<mat-form-field class="width-100" subscriptSizing="dynamic">
	<mat-label class="small-above-label">
		{{ configuration()?.label ? (configuration().label | translate) : '' }}
	</mat-label>
	<mat-select
		[formControl]="formControlForUI"
		[(value)]="selectedDeviation"
		(selectionChange)="selectionchangeHandler($event)"
	>
		<mat-option [value]="'0'">{{ 'none' | translate }}</mat-option>
		@for (option of configuration()?.enumValues || []; track option) {
			<mat-option [value]="option.name">
				{{ option.description | translate }}
			</mat-option>
		}
	</mat-select>
</mat-form-field>
